<template>
  <div class="">
    <el-button type="success" @click="getExtendedReviews">
      Get Extended Reviews
    </el-button>
    <div v-if="extendedReviews.length">
      <div class="table-title">Reviews</div>
      <el-table :data="extendedReviews" style="width: 100%">
        <el-table-column
          prop="userId"
          label="User"
          width="200"
          header-align="center"
        >
          <template #default="scope">
            <div class="group relative">
              <div v-if="scope.row.userId" class="truncate">
                {{ scope.row.userId.email }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="reviewerEmail"
          label="Reviewer"
          header-align="center"
          width="200"
        >
          <template #default="scope">
            <div class="group relative">
              <div class="truncate">
                {{ scope.row.reviewerId.email }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="Status"
          header-align="center"
          width="80"
        >
          <template #default="scope">
            <div
              :class="{
                'bg-yellow-800': scope.row.reviewerId.status === 'archived',
                'bg-green-800': scope.row.reviewerId.status === 'reviewed',
              }"
            >
              {{ scope.row.reviewerId.status }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="rating"
          label="R"
          width="40"
          header-align="center"
        >
          <template #default="scope">
            <div
              :class="{
                'bg-yellow-800': scope.row.rating === 3,
                'bg-green-800': scope.row.rating === 5,
                'bg-red-800': scope.row.rating === 2 || scope.row.rating === 1,
              }"
            >
              {{ scope.row.rating }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="Created At"
          header-align="center"
          width="200"
        >
          <template #default="scope">
            <div>{{ scope.row.createdAt }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="comment"
          label="Comment"
          header-align="center"
          width="200"
        >
          <template #default="scope">
            <div>{{ scope.row.comment }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="feedback"
          label="Feedback"
          header-align="center"
          width="200"
        >
          <template #default="scope">
            <div>{{ scope.row.feedback }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import api from "@/composables/api";

const extendedReviews = ref([]);

const getExtendedReviews = () => {
  api(`v1/review/extended/`).then((res) => {
    // console.log(res.data.reviews);
    if (res.data && res.data.reviews.length > 0) {
      extendedReviews.value = res.data.reviews;
    }
  });
  // console.log("get extended reviews");
};
</script>

<style scoped>
.table-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}
</style>
